/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import MainResults from './components/MainResults.vue'
import SearchForm from './components/SearchForm.vue'
import SearchResults from './components/SearchResults.vue'
import StraightResult from "./components/StraightResult.vue";
import analytics from './tools/ga'
import Vue from 'vue';
import {onLCP, onFID, onCLS, onFCP, onTTFB, onINP} from 'web-vitals';
import { initContactForm } from './tools/feedback';
import { createSignedRequestClient } from './tools/signedRequestClient';
import { expBus } from '@js-packages/experiment-loader';
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
require('./experiment/experimentLoader');
require('./tools/languageToggler');
require('./tools/faqDropdown');
require('./tools/createArrow');
onCLS(analytics.sendWebVitalsToGA);
onFID(analytics.sendWebVitalsToGA);
onLCP(analytics.sendWebVitalsToGA);
onFCP(analytics.sendWebVitalsToGA);
onTTFB(analytics.sendWebVitalsToGA);
onINP(analytics.sendWebVitalsToGA);
const app = new Vue({
    el: '#main',
    components: {
        SearchResults,
        StraightResult,
        MainResults,
        SearchForm,
    },
    beforeMount() {
        // не реактивное поле: клиент держит своё состояние сам, Vue за ним не следит
        this.signedRequest = createSignedRequestClient({
            load: () => import(
                /* webpackChunkName: "link.chunk" */
                './tools/getSignedRequestBody.js'
            ),
        });
        // намеренно без await: ожидание перенесено в момент запроса
        this.initSignedRequest();
    },
    async mounted() {
        this.$on('link-insert', (link) => {
            analytics.linkInsert(link)
        })
        this.$on('link-submit', (link) => {
            analytics.linkSubmit(link)
            expBus.emit('clickAds', 'open')
        })
        this.$on('link-submit-posts', (link) => {
            analytics.linkSubmit(link)
        })
        this.$on('link-submit-stories', (link) => {
            analytics.linkSubmit(link)
        })
        this.$on('link-submit-reels', (link) => {
            analytics.linkSubmit(link)
        })
        this.$on('straight-submit', (link) => {
            analytics.linkSubmit(link)
        })
        this.$on('link-cast', (link) => {
            analytics.linkInsert(link)
        })
        this.$on('search-request', () => {
            expBus.emit('clickAds', 'open')
        })
        /**
         * TEA-6094: источник скачивания ('playlist') приходит в самом событии —
         * общего состояния на root нет, поэтому чужие скачивания его не подхватывают.
         *
         * Канонические сигнатуры событий аналитики. Аргументы позиционные, поэтому
         * новые вызывающие обязаны соблюдать порядок целиком, даже если передают
         * не все значения. `source` всегда последний и по умолчанию 'direct';
         * полный список значений — в блоке про dimension2 в tools/ga.js.
         *
         *   Source = 'playlist' | 'direct'
         *
         *   $emit('search-download', link: string, source?: Source)
         *   $emit('download-click',  link: string, format: string, source?: Source)
         *   $emit('show-results',    result: object, link: string, format: string|null, source?: Source)
         *   $emit('show-error',      e: object|null, link: string, source?: Source)
         *
         * format у 'show-results' бывает null: карточка выдачи шлёт событие до того,
         * как пользователь выбрал качество.
         *
         * Неиспользуемые здесь параметры помечены префиксом `_`: они нужны только
         * для позиционного доступа к тому, что идёт следом.
         */
        this.$on('search-download', (link, source) => {
            analytics.searchDownload(link, source)
        })
        this.$on('download-click', (link, format, source) => {
            analytics.downloadClick(link, format, source)
            expBus.emit('clickAds', 'open')
        })
        this.$on('show-results', (_result, link, _format, source) => {
            analytics.showResults(link, source);
        })
        this.$on('show-error', (e, _link, source) => {
            analytics.showError(e, source);
        })
        const contactForm = document.getElementById('contactForm');
        if (contactForm) {
            const translations = contactForm.dataset.translations
                ? JSON.parse(contactForm.dataset.translations)
                : {};
            initContactForm(translations);
        }
    },
    methods: {
        initSignedRequest() {
            // загрузку запускаем заранее, но ничего не ждём: ожидание живёт в момент
            // самого запроса, см. tools/signedRequestClient.js
            this.signedRequest.start();
        },
        subscribeSignedRequestBody(url) {
            return this.signedRequest.signBody(url);
        },
    },
})
